const utils = require("frontend-controller/lib/utils");
module.exports = {
    extends: [
        '/',
        'templates',
        'crew',
        'scheduler',
        'scheduler',
    ],

    config: {
        showNav: {
            showOptions: false
        }
    },

    model: {
        resourceFilters: {
            filters:  {
                loadScheduleOnly: true
            }
        }
    },

    methods: {
        loadResourcesGranted(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
            if(actionKey === 'refreshResources'){
                return utils.collectionSize((resourceFilters || {}).filters) > 0
            }

            return true
        },
    }
}